var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 161,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.554 19.497a.458.458 0 0 1-.038-.654l2.789-3.079-3.122-2.74a.458.458 0 0 1-.038-.654.475.475 0 0 1 .664-.038l3.473 3.048c.194.17.211.463.037.654l-3.101 3.425a.475.475 0 0 1-.664.038Z",
    fill: "#C5CBD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38 152.061C153.658 147.849 94.822 18.333 195.5 15.807",
    stroke: "#C5CBD1",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })));
};
export default SvgArrow;